import { render, staticRenderFns } from "./ChangeTime.vue?vue&type=template&id=23330d1a&scoped=true&"
import script from "./ChangeTime.vue?vue&type=script&lang=js&"
export * from "./ChangeTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23330d1a",
  null
  
)

export default component.exports